



























import Vue from 'vue';
import AdmissionTypeSelectionForm from '@/components/forms/AdmissionTypeSelectionForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import pipeline from '@/pipeline';
import { AdmissionType } from '@/store/modules/admission/state';
import Analytics from '@/helpers/analytics';
import { Toast } from '@descomplica/vue-components';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    AdmissionTypeSelectionForm,
    PipelineMenuWrapper,
    BackButton,
    Toast,
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    availableAdmissionTypes(): AdmissionType[] {
      return this.$store.getters.availableAdmissionTypes || [];
    },
    selectedAdmissionType(): string {
      return this.$store.getters.selectedAdmissionType?.id;
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_ADMISSION_TYPES');
  },
  methods: {
    async selectedHandler(admissionType: AdmissionType) {
      await this.$store
        .dispatch('UPDATE_ADMISSION_TYPE', { admissionType })
        .catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.EVALUATION_TYPE_CHOSEN, {
        email: this.$store.getters.user.email,
        evaluationType: admissionType.name,
        grad_processo_seletivo: admissionType.name,
        processoSeletivoId: this.$store.getters.admissionId,
      });
      Analytics.trackGTM({
        event: 'evaluation_type_selected',
        grad_selected_evaluation_type: admissionType.name,
        processo_seletivo_id: this.$store.getters.admissionId,
      });

      pipeline.next({ value: admissionType.stateKey });
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
